import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-common-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './common-loader.component.html',
  styleUrl: './common-loader.component.scss',
})
export class CommonLoaderComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  ngOnInit(): void {}
}
